export const GET_SUBSCRIPTIONS = "GET_SUBSCRIPTIONS";
export const CANCEL_SUBSCRIPTION = "CANCEL_SUBSCRIPTION";
export const CREATE_SUBSCRIPTION = "CREATE_SUBSCRIPTION";
export const GET_REFERREDS = "GET_REFERREDS";
export const CHECK_SUBSCRIPTION = "CHECK_SUBSCRIPTION";
export const UPDATE_SUBSCRIPTION = "UPDATE_SUBSCRIPTION";
export const GET_GATEWAY = "GET_GATEWAY";
export const FINALIZE_TRANSACTION = "FINALIZE_TRANSACTION";
export const CLEAR_GATEWAY = "CLEAR_GATEWAY";
